import React, { Component } from "react";
import { connect } from "react-redux";
import ContactUsForm from "Forms/ContactUsForm";
import styled from "styled-components";
import { TitleHeader } from "Themes/StyledComponents";
import { mobileSize } from "Themes/Metrics";
import AppConfig from "Config/AppConfig";

const Container = styled.div`
  width: 40%;
  margin: auto;
  margin-top: 10%;
  @media ${mobileSize.large} {
    width: 70%;
  }
`;

class ContactUsContainer extends Component {
  state = {
    fetching: false,
    success: false,
    error: false,
  };

  handleSubmit = (vals) => {
    this.setState({ fetching: true });
    fetch(`${AppConfig.APIServer}users/contact-us/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(vals),
    })
      .then(() => {
        this.setState({
          success: true,
          fetching: false,
        });
      })
      .catch(() => {
        this.setState({
          error: true,
          fetching: false,
        });
      });
  };

  render() {
    const { fetching, success, error } = this.state;
    return (
      <Container>
        <TitleHeader>Contact Us</TitleHeader>
        <ContactUsForm
          handleSubmit={this.handleSubmit}
          fetching={fetching}
          error={error}
          success={success}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactUsContainer);
